(function () {
	const mediaBanner = () => {
		document.querySelectorAll(".media-banner").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			const sectionElement = box;
			block = $(block);

			const stickyEffect = block.data("sticky-effect");

			if (stickyEffect) {
				var normalElement = document.querySelector(`#${id} + .sticky-section`);
				if (normalElement == null) {
					return;
				}

				var isSticky = false;

				window.addEventListener("scroll", function () {
					var stickyTop = box.getBoundingClientRect().top;
					var normalElementTop = normalElement.getBoundingClientRect().top;

					if (stickyTop <= 0 && !isSticky) {
						box.classList.add("sticky-active");
						isSticky = true;
					}

					if (normalElementTop <= 0 && isSticky) {
						box.classList.remove("sticky-active");
						isSticky = false;
					}
				});
			}

			const mediaVideos = sectionElement.querySelectorAll(".media-banner__video");
			if (mediaVideos.length) {
				const playVideo = (videoWrapper) => {
					const localVideo = videoWrapper.querySelector(".media-banner-video");
					if (localVideo) {
						localVideo
							.play()
							.catch(() => {});
					}

					const iframe = videoWrapper.querySelector("iframe");
					if (!iframe) return;

					if (iframe.classList.contains("js-youtube")) {
						iframe.contentWindow?.postMessage(
							'{"event":"command","func":"playVideo","args":""}',
							"*"
						);
					} else if (iframe.classList.contains("js-vimeo")) {
						iframe.contentWindow?.postMessage('{"method":"play"}', "*");
					}
				};

				const pauseVideo = (videoWrapper) => {
					const localVideo = videoWrapper.querySelector(".media-banner-video");
					if (localVideo) {
						localVideo.pause();
					}

					const iframe = videoWrapper.querySelector("iframe");
					if (!iframe) return;

					if (iframe.classList.contains("js-youtube")) {
						iframe.contentWindow?.postMessage(
							'{"event":"command","func":"pauseVideo","args":""}',
							"*"
						);
					} else if (iframe.classList.contains("js-vimeo")) {
						iframe.contentWindow?.postMessage('{"method":"pause"}', "*");
					}
				};

				mediaVideos.forEach((videoWrapper) => {
					const playOnHover = videoWrapper.dataset.playOnHover === "true";
					const slide = videoWrapper.closest(".media-banner__slide");
					if (!slide) return;

					let inViewport = false;

					if (playOnHover) {
						videoWrapper.classList.remove("autoplay");
						pauseVideo(videoWrapper);

						slide.addEventListener("mouseenter", () => {
							if (!inViewport) return;
							playVideo(videoWrapper);
						});

						slide.addEventListener("mouseleave", () => {
							pauseVideo(videoWrapper);
						});
					}

					const observer = new IntersectionObserver((entries) => {
						entries.forEach((entry) => {
							inViewport = entry.isIntersecting;

							if (!entry.isIntersecting) {
								pauseVideo(videoWrapper);
								return;
							}

							if (playOnHover) return;

							playVideo(videoWrapper);
						});
					});

					observer.observe(slide);
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		mediaBanner();
		document.addEventListener("shopify:section:load", function () {
			mediaBanner();
		});
	});
})();

//document.addEventListener("DOMContentLoaded", function () {
//	var stickyElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner"
//	);
//	var normalElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner-2"
//	);
//	var isSticky = false; // Track whether the element is sticky

//	window.addEventListener("scroll", function () {
//		var stickyTop = stickyElement.getBoundingClientRect().top;
//		var normalElementTop = normalElement.getBoundingClientRect().top;

//		// Add sticky class when sticky element reaches the top of the viewport
//		if (stickyTop <= 0 && !isSticky) {
//			stickyElement.classList.add("sticky-active");
//			isSticky = true; // Set sticky state to true
//		}

//		// Remove sticky class if the second section is in the viewport
//		if (normalElementTop <= 0 && isSticky) {
//			stickyElement.classList.remove("sticky-active");
//			isSticky = false; // Set sticky state to false
//		}
//	});
//});
